<template>
  <div class="home">
    <!-- <a class="openapp" :href="this.$config.iOSAPPUrl">Open app</a> -->
    <div>
      <img
        class="logo"
        src="/public/lmk_text@2x.png"
      >
    </div>
    <div>
      <img
        class="slogan"
        src="/public/slogan.png"
      >
    </div>
    <div class="appstore clear">
      <div
        v-if="download"
        class="download-guide"
      >
        <img src="/public/download_guide.png">
      </div>
      <div class="btn-download-group">
        <a
          v-if="ios"
          href="this.$config.iOSAPPUrl"
          @click="handleEvent"
        >Download the app</a>
        <a
          v-if="android"
          href="this.$config.androidAPPUrl"
          @click="handleEvent"
        >Download the app</a>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../common/Footer.vue";

export default {
  name: "Home",

  components: {
    Footer,
  },
  data () {
    return {
      'download': false,
      'ios': (this.$store.state.device == 'ios' || this.$store.state.device == 'desktop'),
      'android': (this.$store.state.device == 'android' || this.$store.state.device == 'desktop'),
      'desktop': (this.$store.state.device == 'desktop') ? true : false,
    }
  },
  methods: {
    copy: function() {
      this.download = true
    },
    handleEvent: function(event) {
      var elem = document.getElementById('btn_copy')
      if(elem) {
        elem.click()
      }
    },
  },
};
</script>

<style lang="stylus">
.home
  text-align center
  background #FFFC00
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  .logo
    width 136px
    margin-top 112px

  .slogan
    height 80px
    margin-top 32px
.appstore
  margin: 64px auto
  position relative
  text-align center


  .download-guide
    text-align center
    position: absolute;
    top: 10px;
    width: 100%;
    img
      height 16px;
  .btn-download-group
    margin 36px auto 0
    padding: 0 0 10px 0
    img
      width 214px


.mobile .appstore a
  margin 0 auto
  display block
  font-size: 18px;
  line-height: 56px;
  text-align: center;
  font-weight bold
  height: 56px;
  width: 240px;
  border-radius: 32px;
  box-shadow: inset 0 -0.5px 0 0 rgba(208,214,217,0.75), 0 2px 8px 0 rgba(0,0,0,0.25);

  background-color: #ffffff;
  color #000000

</style>



// WEBPACK FOOTER //
// HomeAd.vue